import { render, staticRenderFns } from "./ProjectCostDetailTable.vue?vue&type=template&id=54b5acbb&scoped=true&"
import script from "./ProjectCostDetailTable.vue?vue&type=script&lang=js&"
export * from "./ProjectCostDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCostDetailTable.vue?vue&type=style&index=0&id=54b5acbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5acbb",
  null
  
)

export default component.exports